// Create a vue app
import { createApp } from 'vue';
import PlannedTrails from "./PlannedTrails.vue";
import { i18n } from '../../i18n';


if (document.getElementById('planned-trails') != null) {
  const app = createApp(PlannedTrails);
  app.use(i18n);
  app.mount('#planned-trails');
}
